import React from 'react';

import { ReactComponent as LogoSVG } from '../../images/pefa-logo.svg';
import { Container } from './logo.styles';

export const Logo = (props) => (
  <Container {...props}>
    <LogoSVG width={'100%'} height={'100%'} preserveAspectRatio={'xMinYMin meet'} />
  </Container>
);
